import { useLang } from '../../../context/LanguageContext';

const quickLinks = [
  { labelRo: 'Sisteme de Alarmă', labelRu: 'Системы Сигнализации', href: '#services' },
  { labelRo: 'Supraveghere Video', labelRu: 'Видеонаблюдение', href: '#services' },
  { labelRo: 'Interfoane', labelRu: 'Домофоны', href: '#services' },
  { labelRo: 'Smart Home', labelRu: 'Умный дом', href: '#services' },
  { labelRo: 'Cum Funcționează', labelRu: 'Как работает', href: '#how-it-works' },
  { labelRo: 'De Ce Noi', labelRu: 'Почему мы', href: '#why-us' },
];

const brandLinks = ['Ajax Systems', 'Hikvision', 'Dahua', 'Paradox', 'Bosch Security', 'Ezviz'];

const messengers = [
  {
    label: 'WhatsApp',
    icon: 'ri-whatsapp-line',
    href: 'https://wa.me/37360123456?text=Buna%20ziua!%20Doresc%20un%20deviz%20gratuit.',
    color: '#25D366',
  },
  {
    label: 'Viber',
    icon: 'ri-chat-voice-line',
    href: 'viber://add?number=37360123456',
    color: '#7360F2',
  },
  {
    label: 'Telegram',
    icon: 'ri-telegram-line',
    href: 'https://t.me/myalarm_md',
    color: '#26A5E4',
  },
];

export default function Footer() {
  const { t } = useLang();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-charcoal border-t border-neon/10 pt-16 pb-8 relative overflow-hidden">
      <div className="absolute inset-0 cyber-grid-bg opacity-15"></div>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon/40 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-5">
              <span className="font-rajdhani font-bold text-3xl tracking-wide">
                <span className="text-white">My</span>
                <span className="text-neon" style={{ textShadow: '0 0 10px rgba(0,255,136,0.5)' }}>Alarm</span>
              </span>
            </div>
            <p className="font-inter text-sm text-cyber-muted leading-relaxed mb-6 max-w-xs">
              {t(
                'Sisteme profesionale de alarmă și supraveghere pentru locuințe și afaceri în Moldova.',
                'Профессиональные системы сигнализации и видеонаблюдения для домов и бизнеса в Молдове.'
              )}
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://wa.me/37360123456"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-neon/10 border border-neon/25 text-neon hover:bg-neon hover:text-charcoal transition-all duration-200 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a
                href="https://t.me/myalarm_md"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-neon/10 border border-neon/25 text-neon hover:bg-neon hover:text-charcoal transition-all duration-200 cursor-pointer"
              >
                <i className="ri-telegram-line text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-neon/10 border border-neon/25 text-neon hover:bg-neon hover:text-charcoal transition-all duration-200 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-sm mb-5 uppercase tracking-widest">
              <a href="#services" onClick={(e) => handleNavClick(e, '#services')} className="hover:text-neon transition-colors cursor-pointer">
                {t('Servicii', 'Услуги')}
              </a>
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.labelRo}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="font-inter text-sm text-cyber-muted hover:text-neon transition-colors flex items-center gap-2 cursor-pointer"
                  >
                    <span className="w-1 h-1 rounded-full bg-neon/40 flex-shrink-0"></span>
                    {t(link.labelRo, link.labelRu)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Brands */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-sm mb-5 uppercase tracking-widest">
              <a href="#brands" onClick={(e) => handleNavClick(e, '#brands')} className="hover:text-neon transition-colors cursor-pointer">
                {t('Mărci', 'Бренды')}
              </a>
            </h4>
            <ul className="space-y-2.5">
              {brandLinks.map((b) => (
                <li key={b}>
                  <span className="font-inter text-sm text-cyber-muted flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-neon/40 flex-shrink-0"></span>
                    {b}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-sm mb-5 uppercase tracking-widest">
              {t('Contact', 'Контакты')}
            </h4>

            <div className="space-y-3 mb-5">
              {/* Phone */}
              <a
                href="tel:+37360123456"
                className="flex items-center gap-2.5 group cursor-pointer"
              >
                <i className="ri-phone-line text-neon text-sm flex-shrink-0"></i>
                <span className="font-inter text-sm text-cyber-text group-hover:text-neon transition-colors">
                  +373 60 123 456
                </span>
              </a>

              {/* Email */}
              <a
                href="mailto:info@myalarm.md"
                className="flex items-center gap-2.5 group cursor-pointer"
              >
                <i className="ri-mail-line text-neon text-sm flex-shrink-0"></i>
                <span className="font-inter text-sm text-cyber-text group-hover:text-neon transition-colors">
                  info@myalarm.md
                </span>
              </a>

              {/* Location */}
              <div className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-neon text-sm flex-shrink-0 mt-0.5"></i>
                <span className="font-inter text-sm text-cyber-muted leading-snug">
                  {t('str. Ștefan cel Mare 1, Chișinău', 'ул. Штефан чел Маре 1, Кишинёв')}
                </span>
              </div>

              {/* Hours */}
              <div className="flex items-center gap-2.5">
                <i className="ri-time-line text-neon/50 text-sm flex-shrink-0"></i>
                <span className="font-inter text-xs text-cyber-muted/70">
                  {t('Lun–Dum: 08:00–21:00', 'Пн–Вс: 08:00–21:00')}
                </span>
              </div>
            </div>

            {/* Messenger buttons */}
            <div className="flex flex-wrap gap-2">
              {messengers.map((m) => (
                <a
                  key={m.label}
                  href={m.href}
                  target={m.label !== 'Viber' ? '_blank' : undefined}
                  rel={m.label !== 'Viber' ? 'nofollow noreferrer' : undefined}
                  className="flex items-center gap-1.5 px-3 py-2 rounded-md border text-xs font-rajdhani font-bold transition-all duration-200 cursor-pointer hover:scale-105"
                  style={{
                    borderColor: `${m.color}40`,
                    backgroundColor: `${m.color}10`,
                    color: m.color,
                  }}
                  onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = `${m.color}20`; }}
                  onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = `${m.color}10`; }}
                >
                  <i className={`${m.icon} text-base`}></i>
                  <span>{m.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-charcoal-300 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-inter text-xs text-cyber-muted">
            © 2025 MyAlarm — {t('Sisteme de Securitate, Chișinău, Moldova. Toate drepturile rezervate.', 'Системы безопасности, Кишинёв, Молдова. Все права защищены.')}
          </p>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-neon animate-pulse"></span>
            <span className="font-inter text-xs text-neon/70">{t('Sistem Activ 24/7', 'Система активна 24/7')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
